import React from 'react'

import { Box, NumberBadge, Text } from '@factorialco/deprecated-design-system'

interface Props {
  competencyName: string
  levelName?: string
  position?: number
  children: React.ReactNode
}

export const CompetencyAssignCard: React.FC<Props> = ({
  competencyName,
  levelName,
  position,
  children,
}) => {
  return (
    <Box
      padding="s24"
      gap="s8"
      flexDirection="row"
      justifyContent="spaceBetween"
      width="full"
      border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
      borderRadius={{ all: 'abs008' }}
    >
      {position && <NumberBadge label={position} textColor="grey1000" />}

      <Box gap="s16" width="full">
        <Box gap="s4" flexDirection="row" alignItems="center">
          <Text.Normal size="300" weight="medium" color={levelName ? 'grey800' : 'textPrimary'}>
            {competencyName} {levelName ? '/' : ''}
          </Text.Normal>
          {levelName && (
            <Text.Normal size="300" weight="semibold" color="textPrimary">
              {levelName}
            </Text.Normal>
          )}
        </Box>

        {children}
      </Box>
    </Box>
  )
}
